'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSendNewEmailCapturePromptMessage = undefined;

var _hasBotMessages = require('./hasBotMessages');

var _hasEmailCapturePromptFromCurrentSession = require('./hasEmailCapturePromptFromCurrentSession');

var _enoughTimeHasPassedForNewAutomatedChatMessage = require('./enoughTimeHasPassedForNewAutomatedChatMessage');

var _hasAgentReplyFromCurrentSession = require('./hasAgentReplyFromCurrentSession');

var canSendNewEmailCapturePromptMessage = exports.canSendNewEmailCapturePromptMessage = function canSendNewEmailCapturePromptMessage(threadHistory) {
  return !(0, _hasAgentReplyFromCurrentSession.hasAgentReplyFromCurrentSession)(threadHistory) && !(0, _hasBotMessages.hasBotMessages)(threadHistory) && (!(0, _hasEmailCapturePromptFromCurrentSession.hasEmailCapturePromptFromCurrentSession)(threadHistory) || (0, _enoughTimeHasPassedForNewAutomatedChatMessage.enoughTimeHasPassedForNewAutomatedChatMessage)(threadHistory));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/canSendNewEmailCapturePromptMessage.js
// module id = 743
// module chunks = 2 3